// _neu_generated_code__dont_modify_directly_
/*DEFAULT GENERATED TEMPLATE. DO NOT CHANGE CLASS NAME*/
//CORE_REFERENCE_IMPORTS
//append_imports_start

import { Component, Injector, Input } from '@angular/core'; //_splitter_
import { SDPageCommonService } from 'app/n-services/sd-page-common.service'; //_splitter_
import { SDBaseService } from 'app/n-services/SDBaseService'; //_splitter_
import { NeuServiceInvokerService } from 'app/n-services/service-caller.service'; //_splitter_
//append_imports_end

@Component({
  selector: 'bh-creditReportCard',
  templateUrl: './creditReportCard.template.html',
  providers: [
    //appendnew_element_providers
  ],
})
export class creditReportCardComponent {
  @Input('report')
  public report: any = undefined;
  page: any = { dep: {} };
  constructor(
    private __page_injector__: Injector,
    private sdService: SDBaseService,
    public __serviceInvoker__: NeuServiceInvokerService
  ) {
    this.__page_injector__.get(SDPageCommonService).addPageDefaults(this.page);
    this.registerListeners();
    //appendnew_element_inject
  }

  ngOnInit() {
    const bh: any = this.__page_injector__
      .get(SDPageCommonService)
      .constructFlowObject(this);
    {
      this.sd_ZYHoh012MdYUnOxW(bh);
    }
  }

  private registerListeners() {
    let bh = this.__page_injector__
      .get(SDPageCommonService)
      .constructFlowObject(this);

    //append_listeners
  }

  sd_ZYHoh012MdYUnOxW(bh) {
    try {
      bh = this.sd_5DqwpD8KpHU2USh6(bh);
      //appendnew_next_sd_ZYHoh012MdYUnOxW
      return bh;
    } catch (e) {
      return this.errorHandler(bh, e, 'sd_ZYHoh012MdYUnOxW');
    }
  }

  getScoreColor(score = 0, ...others) {
    let bh: any = {};
    try {
      bh = this.__page_injector__
        .get(SDPageCommonService)
        .constructFlowObject(this);
      bh.input = { score };
      bh.local = { className: undefined };
      bh = this.sd_cgXKEWfoLjmnbsXp(bh);
      //appendnew_next_getScoreColor
      return bh.local.className;
    } catch (e) {
      return this.errorHandler(bh, e, 'sd_LOhPyxV6WvwrRcYT');
    }
  }
  //appendnew_flow_creditReportCardComponent_start

  sd_5DqwpD8KpHU2USh6(bh) {
    try {
      //appendnew_next_sd_5DqwpD8KpHU2USh6
      return bh;
    } catch (e) {
      return this.errorHandler(bh, e, 'sd_5DqwpD8KpHU2USh6');
    }
  }

  sd_cgXKEWfoLjmnbsXp(bh) {
    try {
      const page = this.page;
      if (bh.input.score >= 740) {
        bh.local.className = 'text-green';
      } else if (bh.input.score >= 670) {
        bh.local.className = 'text-blue';
      } else if (bh.input.score >= 580) {
        bh.local.className = 'text-yellow';
      } else {
        bh.local.className = 'text-red';
      }
      //appendnew_next_sd_cgXKEWfoLjmnbsXp
      return bh;
    } catch (e) {
      return this.errorHandler(bh, e, 'sd_cgXKEWfoLjmnbsXp');
    }
  }

  //appendnew_node

  ngOnDestroy() {
    const bh: any = this.__page_injector__
      .get(SDPageCommonService)
      .constructFlowObject(this);
    this.__page_injector__.get(SDPageCommonService).deletePageFromMap(this);
  }

  // error_handler_slot
  private errorHandler(bh, e, src): Promise<any> {
    console.error(e);
    bh.error = e;
    bh.errorSource = src;
    throw e;
  }
  //appendnew_flow_creditReportCardComponent_Catch
}
